import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router';
import InviteToProjectButton from './InviteToProjectButton';

const mounted = new Set();

/**
 * Unmounts disconnected nodes, then mounts/updates React invite controls on
 * `[data-browse-invite-react]` placeholders inside the InstantSearch hits list.
 */
export function syncBrowseInviteIslands(
  container,
  { history, getInviteProps }
) {
  if (typeof document === 'undefined' || !container || !history) {
    return;
  }

  [...mounted].forEach((node) => {
    if (!node.isConnected) {
      ReactDOM.unmountComponentAtNode(node);
      mounted.delete(node);
    }
  });

  const nodes = container.querySelectorAll('[data-browse-invite-react]');
  nodes.forEach((node) => {
    const username = node.getAttribute('data-username') || '';
    const userId = node.getAttribute('data-user-id') || '';
    if (!username || !userId) {
      return;
    }

    const p = typeof getInviteProps === 'function' ? getInviteProps() : {};
    const tree = (
      <Router history={history}>
        <InviteToProjectButton
          user={{ username, id: userId }}
          collaborations={p.collaborations}
          isLoadingOwnBriefs={p.isLoadingOwnBriefs}
          isBriefInviteBlockedForUser={p.isBriefInviteBlockedForUser}
          isMobile={p.isMobile}
          authUser={p.authUser}
          onSendInvite={p.onSendInvite}
          onOpenChooserModal={p.onOpenChooserModal}
        />
      </Router>
    );

    ReactDOM.render(tree, node);
    mounted.add(node);
  });
}

export function teardownBrowseInviteIslands() {
  [...mounted].forEach((node) => {
    ReactDOM.unmountComponentAtNode(node);
    mounted.delete(node);
  });
}
